export const ensureIosSmartBanner = (appStoreId: string): void => {
  const existing = document.querySelector<HTMLMetaElement>('meta[name="apple-itunes-app"]');
  if (existing?.content.includes('app-clip-bundle-id=')) return;

  const tag = existing ?? document.createElement('meta');
  tag.name = 'apple-itunes-app';
  tag.content = `app-id=${appStoreId}`;
  if (!existing) document.head.appendChild(tag);
};
